<p>auth-logout works!</p>
